import {
  clientDocumentsVisibilityColumns,
  debtorDocumentsVisibilityColumns,
} from '@riskMatrix/components/DocumentsDataTable/visibilityColumns';
import { type DataSetConfig } from '@store/dataSetConfigs/types';

const CLIENT_PORTFOLIO_DOCUMENTS_CONFIG_KEY = 'clientPortfolioDocuments';
const DEBTOR_PORTFOLIO_DOCUMENTS_CONFIG_KEY = 'debtorPortfolioDocuments';

const initialClientPortfolioDocumentsConfig: DataSetConfig = {
  sorting: [],
  columnsVisibility: clientDocumentsVisibilityColumns,
};
const initialDebtorPortfolioDocumentsConfig: DataSetConfig = {
  sorting: [],
  columnsVisibility: debtorDocumentsVisibilityColumns,
};

export {
  CLIENT_PORTFOLIO_DOCUMENTS_CONFIG_KEY,
  DEBTOR_PORTFOLIO_DOCUMENTS_CONFIG_KEY,
  initialClientPortfolioDocumentsConfig,
  initialDebtorPortfolioDocumentsConfig,
};
